import { Form, Formik } from "formik"
import * as yup from "yup"
import { Box } from "@mui/material"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { StandardForm } from "../../../../../../shared/components/forms/StandardForm"
import { StandardMainPanel } from "../../../../../../shared/components/forms/StandardMainPanel"
import { StandardLoadingButton } from "../../../../../../shared/components/buttons/LoadingButton"
import { ManageBookingsFormContent } from "./ManageBookingsFormContent"
import { ManageBookingsAction, ManageBookingsFormValues } from "../manageBookingsTypes"

type Props = Readonly<{
    onSubmit: (values: ManageBookingsFormValues) => Promise<void>
}>

const initialValues: ManageBookingsFormValues = {
    company: null,
    user: null,
    action: "",
    updateResourceBooking: false,
    updateMeetingService: false,
    newBookingOwner: null,
}

export function ManageBookingsForm({ onSubmit }: Props) {
    const { l10n } = useAppLocalization()

    const validationSchema = yup.object({
        company: yup.object().nullable().required(l10n.getString("service-center-admin-organization-manage-bookings-error-company-required")),
        user: yup.object().nullable().required(l10n.getString("service-center-admin-organization-manage-bookings-error-user-required")),
        action: yup.string().required(l10n.getString("service-center-admin-organization-manage-bookings-error-action-required")),
        newBookingOwner: yup
            .object()
            .nullable()
            .when("action", {
                is: ManageBookingsAction.CHANGE_ORGANIZER,
                then: (schema) => schema.required(l10n.getString("service-center-admin-organization-manage-bookings-error-new-owner-required")),
            }),
    })

    return (
        <Formik<ManageBookingsFormValues>
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            validateOnBlur={false}
            validateOnChange={false}
        >
            {({ isSubmitting }) => (
                <Form>
                    <StandardForm>
                        <StandardMainPanel>
                            <ManageBookingsFormContent />
                            <Box display="flex" justifyContent="flex-end" mt="3.75rem">
                                <LocalizedStrict id="service-center-admin-organization-manage-bookings-confirm-button">
                                    <StandardLoadingButton type="submit" loading={isSubmitting} fullWidth={false}>
                                        Confirm
                                    </StandardLoadingButton>
                                </LocalizedStrict>
                            </Box>
                        </StandardMainPanel>
                    </StandardForm>
                </Form>
            )}
        </Formik>
    )
}
